document.addEventListener('DOMContentLoaded', () => {
  const switchers = document.querySelectorAll('.luxury-grid-switcher__btn');
  const productGrid = document.getElementById('product-grid');
  
  if (!switchers.length || !productGrid) return;

  const savedCols = localStorage.getItem('luxury_grid_cols') || '3';
  
  function applyGrid(cols) {
    // Force CSS variable to bypass Dawn's native grid logic
    productGrid.style.setProperty('--luxury-grid-cols', cols);
    
    switchers.forEach(btn => {
      btn.classList.toggle('is-active', btn.dataset.cols === cols);
    });
    
    localStorage.setItem('luxury_grid_cols', cols);
  }

  applyGrid(savedCols);

  switchers.forEach(btn => {
    btn.addEventListener('click', () => {
      applyGrid(btn.dataset.cols);
    });
  });
});
